import React, { ComponentType, SVGProps } from "react";
import {
  IconInProgress,
  IconMissingParticipants,
  IconProcessRecording,
  IconRecordingFailed,
  IconRecordingFailedAvailable,
  IconScheduled,
  IconUnknown,
  IconUploadSuccessful,
  IconExternalMeeting,
  IconGoogleMeeting,
  IconMicrosoftMeeting,
  IconZoomMeeting
} from "../../../components/icons";

import { ZoomRecordingStatus } from "../../../tanstackQuery/social-integrations/types";
import { RadioButtonCheckedOutlined } from "@mui/icons-material";

export interface Event {
  id: string;
  day: string;
  date: string;
  month: string;
  isToday: boolean;
  title: string;
  time: string;
  startTime?: Date;
  endTime?: Date;
  isZoomMeeting: boolean;
  meetingId?: string;
  selfHosted: boolean;
  shouldBeRecorded?: boolean;
  meetingType?: number;
  conferenceType?: TConferenceType;
  appTeamID?: string;
  meetingUrl?: string;
  appInterviewID?: string;
  recurringEventId?: string | null;
  meetingStatus?: ZoomRecordingStatus;
  meetingPassword?: string;
  formattedTime?: string;
  description?: string;
  eventLink?: string;
  phone?: string;
  attendees?:string[];
  zoomMeetingDetails:{
    meetingSource:string;
    joinUrl:string | null;
    meetingId:string | null;
    hostedStatus:string;
    isRecurringEvent: boolean;
  }
}

export interface GoogleAuthLoginResponse {
  isSuccessGoogleLogin: boolean;
  type: string;
  errorMessage: string;
}

export interface ZoomAuthLoginResponse {
  isLicensedUser: boolean;
  isSuccess: boolean;
  type: "zoom-auth";
  isPermissionAllowed: boolean;
  errorMessage: string;
  zoomUserUUID: string;
}

export const STATUS_ICON_MAP: Record<
  ZoomRecordingStatus,
  React.FC<SVGProps<SVGSVGElement>>
> = {
  unknownStatus: IconUnknown,
  successful: IconUploadSuccessful,
  upcoming: IconScheduled,
  meetingOngoing: IconInProgress,
  zoomProcessingCloudRecording: IconProcessRecording,
  "failed:cloudRecordingUnavailable": IconRecordingFailed,
  "failed:cloudRecordingAvailable": IconRecordingFailedAvailable,
  noParticipantsJoined: IconMissingParticipants,
  meetingRecording: RadioButtonCheckedOutlined,
  interviewUploading : IconProcessRecording
};

export const STATUS_TEXT_MAP: Record<ZoomRecordingStatus, string> = {
  unknownStatus: "Unknown Status",
  successful: "Interview Uploaded Successfully",
  upcoming: "Interview Scheduled",
  meetingOngoing: "Interview in Progress",
  zoomProcessingCloudRecording: "Processing Interview",
  "failed:cloudRecordingUnavailable": "Interview Cloud Recording Not Enabled",
  "failed:cloudRecordingAvailable":
    "Processing Delayed - Recording retrieval in progress, we'll retry automatically",
  noParticipantsJoined:
    "Missing Participants - Your scheduled interview had no attendees",
  meetingRecording: "Meeting Recording",
  interviewUploading:"Uploading Interview",
};

export type TConferenceType =
  | "Zoom Meeting"
  | "Google Meet"
  | "External Meeting"
  | "Microsoft Team Meeting";

export const IconMeetingMap: {
  [key in TConferenceType]: ComponentType<SVGProps<SVGSVGElement>>;
} = {
  "Google Meet": IconGoogleMeeting,
  "External Meeting": IconExternalMeeting,
  "Zoom Meeting": IconZoomMeeting,
  "Microsoft Team Meeting": IconMicrosoftMeeting
};
